"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement } from "react";
import Tooltip from "./tooltip.js";
export default function renderWrappedTooltipOrChild(child, modifier) {
    if (!child || !isValidElement(child))
        return child;
    if (child.type !== Tooltip)
        return modifier(child);
    const _a = child.props, { triggerElement } = _a, rest = __rest(_a, ["triggerElement"]);
    return _jsx(Tooltip, Object.assign({ triggerElement: modifier(triggerElement) }, rest));
}
//# sourceMappingURL=render-wrapped-tooltip-or-child.js.map